interface LoadingScreenProps {
  label?: string;
}

export default function LoadingScreen({ label = 'Загрузка...' }: LoadingScreenProps) {
  return (
    <div className="min-h-dvh bg-surface-50 flex items-center justify-center" role="status">
      <span className="flex items-center gap-2 text-sm text-surface-500">
        <i className="ri-loader-4-line animate-spin text-xl" aria-hidden="true" />
        {label}
      </span>
    </div>
  );
}
